/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryParams, StringParam } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import { ProfileStatus } from '../common/interfaces/profile.interface';
import ProfileTable from './ProfilesTable';

export interface ProfileTableQueryPrps extends IPaginationQueryParams {
  search?: string;
  status?: ProfileStatus;
}

export type ProfileTableBasicProps = IHOCQueryProps<ProfileTableQueryPrps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
  orderBy: 'created_at',
  orderDirection: OrderDirection.DESC,
});

const ProfileTableWithQueryParams = () => {
  const queryConfig = {
    ...DEFAULT_QUERY_PARAMS,
    search: StringParam,
    status: StringParam,
  };

  return (
    <QueryParams config={queryConfig}>
      {(props: any) => {
        return <ProfileTable {...props} />;
      }}
    </QueryParams>
  );
};

export default ProfileTableWithQueryParams;
